import React from 'react';

import { Badge, BadgeVariant } from 'components/Badge';
import { DemandPattern, demandPatternIconMapping } from 'components/Tooltip/DemandPatternTooltip';

export type DemandPatternBadgeProps = {
  demandPattern: string;
};

const variantMapping = {
  [DemandPattern.NEW_ITEM]: 'primary',
  [DemandPattern.NO_DEMAND]: 'neutral',
  [DemandPattern.SPARSE]: 'warning',
  [DemandPattern.SMOOTH]: 'primary',
  [DemandPattern.SPORADIC]: 'danger',
  [DemandPattern.ERRATIC]: 'danger',
  [DemandPattern.UNSTABLE]: 'danger',
};

export const DemandPatternBadge = ({ demandPattern }: DemandPatternBadgeProps) => {
  const label = (
    <>
      {demandPattern} {demandPatternIconMapping[demandPattern as DemandPattern]}
    </>
  );

  const variant = variantMapping[demandPattern as DemandPattern];

  return <Badge variant={variant as BadgeVariant} label={label} />;
};
